export const authPaths = Object.freeze({
  static: {
    login: '/login',
    autologin: '/auto-login',
    signUp: '/signup',
    successfulSignUp: '/signup-success',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    generatePassword: '/generate-password',
    confirmRegistration: '/confirm-registration',
  },
});
